// extracted by mini-css-extract-plugin
module.exports = {"PlayButton":"VideoPopup_PlayButton__2G8CH","CloseIcon":"VideoPopup_CloseIcon__192Pz","videoContainer":"VideoPopup_videoContainer__cheXB","videoWrap":"VideoPopup_videoWrap__3nv3F"};